import { HttpClient } from '@angular/common/http'
import { managementApi } from '../../app/constants/path.constants'
import { ApiServiceBase } from './api-service-base'

export abstract class MapiServiceBase extends ApiServiceBase {
    constructor(http: HttpClient) {
        super(managementApi, http)
    }
}
